<div class="container">
  <mat-card>
    <mat-card-header>
      <div class="page-title">IBAN Check</div>
    </mat-card-header>
    <mat-card-content class="pt-16">
      <form (ngSubmit)="serviceCheck()" [formGroup]="checkForm">
        <grid-input [placeholder]="'IBAN'" formControlName="iban"
                    grid-tab-index="0" showClear="false">
          <span slot="description">IBAN</span>
        </grid-input>
        <grid-input [placeholder]="'Codice fiscale o Partita IVA'"
                    formControlName="cfvat" showClear="false">
          <span slot="description">Codice Fiscale / Partita IVA</span>
        </grid-input>

        <app-check-iban-result-card [result]="ibanCheckResult" />

        <mat-card-actions>
          <grid-button (click)="resetForm()" class="ml-auto" variant="secondary-ghost">Reset</grid-button>
          <grid-button type="submit" class="ml-1.5" variant="secondary">Ricerca</grid-button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
